<template>
  <div class="wrapper">
    <p class="title">Reject Invitation</p>
    <div class="content">
      <p class="confirmation-title">
        You have been added as a user to the {{ getModalInfo.name }} dashboard.
        Are you sure you want to <b>Reject</b> the invitation?
      </p>
    </div>
    <!-- action btns  -->
    <hr class="h-line" />
    <div class="action-btns">
      <button
        class="submit-btn btn btn-primary"
        size="md"
        @click="onSubmit"
        :disabled="loadingState"
      >
        <i
          v-if="loadingState"
          class="bx bx-loader bx-spin font-size-16 align-middle mr-2 rounded"
        ></i>
        <span v-else>Reject</span>
      </button>
      <button
        class="btn btn-outline-danger"
        @click="$bvModal.hide('rejectInvitation')"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import axios from "axios";

export default {
  data() {
    return {
      loadingState: false,
    };
  },
  computed: {
    ...mapGetters("modal", ["getModalInfo"]),
  },
  methods: {
    ...mapActions("user", ["resetState"]),
    ...mapActions("entities", ["fetchUserEntities"]),
    onSubmit() {
      const { getModalInfo } = this;
      this.loadingState = true;
      let formData = new FormData();
      formData.append("user_id", getModalInfo.pivot.user_id);
      formData.append("entity_id", getModalInfo.entity_id);
      formData.append("server_id", getModalInfo.server_id);
      const user = JSON.parse(localStorage.getItem("user"));
      axios
        .post(
          `${process.env.VUE_APP_BASE_URL}/api/reject-invitation`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Accept: "*",
              "Access-Control-Allow-Origin": "*",
              Authorization: `Bearer ${user.data.access_token}`,
            },
          }
        )
        .then((data) => {
          this.$toast.success(data.data.message);
          setTimeout(() => {
            this.loadingState = false;
          }, 3000);
          this.$bvModal.hide("rejectInvitation");
          this.fetchUserEntities();
        })
        .catch((err) => {
          if (err.response) {
            this.$toast.error(err.response.data.message);
            this.loadingState = false;
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.confirmation-title {
  font-size: 20px;
  color: #787878;
  text-align: center;
  margin-bottom: 40px;
  font-weight: normal;
}
</style>
